import { Avatar, Button, Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SignupForm from './SignupForm'
import { useTheme } from '@mui/material/styles'
import {
  TextBold,
  TextMedium,
  TextRegular,
  TextSemiBold
} from '../../commonComponents/TextStyling'
import AppIcon from '../../commonComponents/AppIcon'
import appassets from '../../utils/appassets'
import { useLocation, useNavigate } from 'react-router-dom'
import { ENV } from '../../ENV'
import serverData from '../../api/ServerData'

export default function Signup () {
  var theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const [recruiterSignup, setRecruiterSignup] = useState(null)

  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detects small screens

  const [dropDownValues, setDropDownValues] = useState([])

  useEffect(function () {
    const searchParams = new URLSearchParams(location.search)
    const type = searchParams.get('type')
    if (type) {
      setRecruiterSignup(type)
    }
  }, [])

  useEffect(function () {
    serverData.getJobPostDropDownValues(
      {},
      result => {
        if (result.status) {
          setDropDownValues(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          console.log('error in getJobPostDropDownValues API:', error)
          // dispatch(logoutUser(navigate))
        }
      }
    )
  }, [])

  const handleRecuiter = name => {
    setRecruiterSignup(name)
  }

  return (
    <div
      style={{
        height: matches ? '' : 'calc(100vh - 65px)',
        marginTop: matches ? '0rem' : '4rem',
        backgroundImage: `url(./images/background-login.png)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {(recruiterSignup === null || !matches) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0px',
            background: theme.palette.background.paper,
            boxShadow: `1px 1px 5px 0px ${theme.palette.text.disabled}`,
            position: 'fixed',
            width: '100%',
            top: 0,
            zIndex: 1
          }}
        >
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => window.open(`${ENV.product_url}`, '__blank')}
          >
            <AppIcon
              style={{
                width: matches ? '80px' : '95px',
                margin: matches ? '1rem' : '8px 0px 8px 10rem'
              }}
            />
          </span>
          {recruiterSignup === null && (
            <TextRegular
              style={{
                color: theme.palette.text.disabled,
                margin: matches ? '1rem' : '1rem 10rem 1rem 0rem'
              }}
            >
              Already have account?
              <TextSemiBold
                style={{
                  color: theme.palette.primary.main,
                  cursor: 'pointer'
                }}
                onClick={() => navigate('/login')}
              >
                {' Login'}
              </TextSemiBold>
            </TextRegular>
          )}
        </div>
      )}
      {/* <div>
        <Divider  />
      </div> */}

      {recruiterSignup != null ? (
        <SignupForm
          name={recruiterSignup}
          setRecruiterSignup={setRecruiterSignup}
          dropDownValues={dropDownValues}
        />
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: matches ? '5rem' : '50px',
              padding: matches ? '0 16px' : '0 40px'
            }}
          >
            {matches ? (
              <TextBold
                style={{
                  fontSize: '28px',
                  fontWeight: 700,
                  lineHeight: '1.2'
                }}
              >
                Join the leading talent crowdsourcing platform in the industry.
              </TextBold>
            ) : (
              <>
                <TextBold
                  style={{
                    fontSize: '48px',
                    fontWeight: 700,
                    lineHeight: '60px'
                  }}
                >
                  Join the leading talent
                </TextBold>

                <TextBold
                  style={{
                    fontSize: '48px',
                    fontWeight: 700,
                    lineHeight: '60px'
                  }}
                >
                  crowdsourcing platform in the industry.
                </TextBold>
              </>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: matches ? '30px' : '24px',
              padding: matches ? '0 16px' : '0px'
            }}
          >
            <TextSemiBold
              style={{
                fontSize: matches ? '14px' : '16px',
                lineHeight: '28px',
                color: theme.palette.text.disabled
              }}
            >
              To join {ENV.product_name}, sign up below...it's{' '}
              <span style={{ color: theme.palette.primary.main }}>FREE</span> to
              join!
            </TextSemiBold>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: matches ? '8px' : '28px',
              padding: matches ? '0 16px' : '0px'
            }}
          >
            <TextRegular
              style={{
                fontSize: matches ? '14px' : '16px',
                lineHeight: '28px',
                color: theme.palette.text.disabled
              }}
            >
              Hiring employees? Click “Create Employer Account.”
            </TextRegular>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: matches ? '0px' : '0px',
              padding: matches ? '0 16px' : '0px'
            }}
          >
            <TextRegular
              style={{
                fontSize: matches ? '14px' : '16px',
                lineHeight: '28px',
                color: theme.palette.text.disabled
              }}
            >
              If you are an independent recruiter or represent a recruiting
              agency, click “Create Recruiter Account.”
            </TextRegular>
          </div>
          {/* div consist both boxses of Recruiters sign in as well employers sing in */}
          <Grid item container justifyContent='center' spacing={2}>
            <Grid item xs={matches ? 12 : 7}>
              <Grid
                container
                spacing={2}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '16px',
                  marginBottom: '16px',
                  flexDirection: matches ? 'column' : 'row'
                }}
              >
                <Grid
                  item
                  xs={matches ? 12 : 5.8}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '16px',
                    padding: 0
                  }}
                >
                  {/* Recruiter box for sign in */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      border: `1px solid ${theme.palette.border.main}`,
                      borderRadius: '8px',
                      width: '100%',
                      height: 'auto',
                      padding: '30px',
                      backgroundColor: theme.palette.background.paper
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      <Avatar
                        src={`${appassets.recruiterIcon}`}
                        alt='employers'
                        style={{
                          backgroundColor: theme.palette.background.default,
                          width: '80px',
                          height: '80px',
                          padding: '15px'
                        }}
                      />
                    </div>
                    <div style={{ fontSize: '20px' }}>
                      <TextMedium
                        style={{ fontSize: '32px', lineHeight: '40px' }}
                      >
                        Recruiters
                      </TextMedium>
                    </div>
                    <div
                      style={{
                        fontStyle: 'italic',
                        fontWeight: 300,
                        flexGrow: 1,
                        lineHeight: '50px'
                      }}
                    >
                      <TextRegular>"Earn more money!"</TextRegular>
                    </div>

                    <div
                      style={{
                        margin: '10px'
                      }}
                    >
                      <Button
                        variant='contained'
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => handleRecuiter('recruiter')}
                      >
                        Create Recruiter Account
                      </Button>
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={matches ? 12 : 5.8}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '16px',
                    padding: 0
                  }}
                >
                  {/* Employers/HR box for sign in */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      border: `1px solid ${theme.palette.border.main}`,
                      borderRadius: '8px',
                      width: '100%',
                      height: 'auto',
                      padding: '30px',
                      backgroundColor: theme.palette.background.paper
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      <Avatar
                        src={`${appassets.employerIcon}`}
                        alt='employers'
                        style={{
                          backgroundColor: theme.palette.background.default,
                          width: '80px',
                          height: '80px',
                          padding: '15px'
                        }}
                      />
                    </div>

                    <div style={{ fontSize: '20px' }}>
                      <TextMedium
                        style={{ fontSize: '32px', lineHeight: '40px' }}
                      >
                        Employers / HR
                      </TextMedium>
                    </div>
                    <div
                      style={{
                        fontStyle: 'italic',
                        fontWeight: 300,
                        flexGrow: 1,
                        lineHeight: '50px'
                      }}
                    >
                      <TextRegular>"Hire Top Talent!"</TextRegular>
                    </div>

                    <div
                      style={{
                        margin: '10px'
                      }}
                    >
                      <Button
                        variant='contained'
                        style={{ textTransform: 'capitalize' }}
                        onClick={() => handleRecuiter('employer')}
                      >
                        Create Employer Account
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  )
}
